import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, roleGuard } from '@fapp/authentication';
import {
  LoggedOutLayoutComponent,
  NoRoleLayoutComponent,
  StaffLayoutComponent,
} from '@fapp/layouts';
import { PageNotFoundComponent } from '@fapp/pages';

import { UserLayoutComponent } from './layouts/roles/user-layout/user-layout.component';
import { PrivacyPolicyComponent } from './views/pages/auth/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './views/pages/auth/terms-of-service/terms-of-service.component';

// TODO: FIX THIS SOMEHOW SO IT REDIRECTS TO LOGIN IF AN EXISTING PAGE HAS BEEN REQUESTED
const routes: Routes = [
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceComponent,
  },
  {
    path: '',
    component: LoggedOutLayoutComponent,
    loadChildren: () =>
      import('./views/pages/auth/auth.module').then(m => m.AuthModule),
    canMatch: [authGuard(false)],
  },
  {
    path: '',
    component: StaffLayoutComponent,
    loadChildren: () =>
      import('./views/pages/staff/staff.module').then(m => m.StaffModule),
    canMatch: [authGuard(true), roleGuard('Admins', 'CompanyAdmin')],
  },
  {
    path: '',
    component: UserLayoutComponent,
    loadChildren: () =>
      import('./views/pages/user/user.module').then(m => m.UserModule),
    canMatch: [
      authGuard(true),
      roleGuard('CompanyAdmin', 'Manager', 'Counter', 'MaintenanceOperator'),
    ],
  },
  {
    path: '',
    component: NoRoleLayoutComponent,
    loadChildren: () =>
      import('./views/pages/no-role/no-role.module').then(m => m.NoRoleModule),
    canMatch: [authGuard(true)],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      onSameUrlNavigation: 'reload',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
